import type { ApprovalRequest } from '@/lib/types';
import { formatPKR } from '../format';
import { BucketShell } from './_BucketShell';
import { readStructuredFields } from './_payload';

export interface TaxMismatchReviewViewProps {
  req: ApprovalRequest;
}

function readText(value: unknown): string {
  if (value === null || value === undefined || value === '') return '-';
  return String(value);
}

function readNumber(value: unknown): number | null {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

function readAmount(value: unknown): string {
  return formatPKR(readNumber(value));
}

export function TaxMismatchReviewView({ req }: TaxMismatchReviewViewProps) {
  const sf = readStructuredFields(req);

  return (
    <BucketShell req={req}>
      <section className="rounded-lg border border-orange-300 bg-orange-50 p-16">
        <p className="text-xs font-semibold uppercase tracking-wide text-orange-800">
          Tax review
        </p>
        <div className="mt-12 grid gap-12 tablet:grid-cols-4">
          <Cell label="GRN" value={readText(sf['grn_no'])} />
          <Cell label="Invoice subtotal" value={readAmount(sf['invoice_subtotal'])} />
          <Cell label="Invoice tax" value={readAmount(sf['invoice_tax_amount'])} />
          <Cell label="Tax rate" value={`${readText(sf['invoice_tax_rate_pct'])}%`} />
        </div>
        <p className="mt-12 text-xs text-neutral-700">
          The Oracle writer rolled back because taxable goods readback did not
          match the invoice gross. Verify the GRN tax/STAX context before retrying
          or manually posting.
        </p>
        <p className="mt-8 font-mono text-xs text-orange-900">
          {readText(sf['error_message'])}
        </p>
      </section>
    </BucketShell>
  );
}

function Cell({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <p className="text-xs font-semibold uppercase tracking-wide text-orange-900">
        {label}
      </p>
      <p className="mt-4 font-mono text-sm font-semibold text-neutral-900">{value}</p>
    </div>
  );
}
